import { CommonEntityRecord } from "../common";

// Автоработы — работы, которые создаются по шаблонам этапа при смене этапа проекта.
// Шаблоны настраиваются в Настройках этапа (Angular).

// Тип поручителя.
export enum AutoJobAuthorType {
  StageChanger = 1, // Пользователь, меняющий этап
  ProjectCreator = 2, // Пользователь, создавший проект
  Role = 3, // Роль без подходящих пользователей в проекте — такую автоработу сохранить нельзя
  Worker = 4, // Конкретный сотрудник
}

export interface AutoJobAuthorInProject extends CommonEntityRecord {
  Type: AutoJobAuthorType;
  Selected: boolean;
  Position: number;
}

export interface AutoJobAuthorDepartment extends CommonEntityRecord {
  Authors: AutoJobAuthorInProject[];
}

// Элемент списка поручителей: либо поручитель, либо отдел с поручителями внутри
export interface AutoJobAuthorHolder {
  IsAuthor: boolean;
  Author: AutoJobAuthorInProject | null;
  Department: AutoJobAuthorDepartment | null;
  Position: number;
}

export interface AutoJobExecutorInProject extends CommonEntityRecord {
  IsWorker: boolean; // false — роль
  Selected: boolean;
  Workers: CommonEntityRecord[]; // Участники проекта в этой роли
  Position: number;
  HasAccess: boolean;
}

export interface AutoJobExecutorDepartment extends CommonEntityRecord {
  Executors: AutoJobExecutorInProject[];
}

// Элемент списка исполнителей: либо исполнитель (сотрудник или роль), либо отдел с сотрудниками
export interface AutoJobExecutorHolder {
  IsExecutor: boolean;
  Executor: AutoJobExecutorInProject | null;
  Department: AutoJobExecutorDepartment | null;
  Position: number;
}

// Шаблон, заполненный сервером для конкретного проекта и перехода.
// *Locked — поле заблокировано шаблоном и в окне не редактируется.
export interface AutoJobTemplateInProject {
  Id: number;
  Text: string;
  TextLocked: boolean;
  AuthorHolders: AutoJobAuthorHolder[];
  AuthorLocked: boolean;
  AuthorIsValid: boolean;
  ExectutorHolders: AutoJobExecutorHolder[];
  ExecutorLocked: boolean;
  NeedChecking: boolean;
  NeedCheckingLocked: boolean;
  Date: string | null;
  DateLocked: boolean;
  Selected: boolean;
  IsMandatory: boolean; // Обязательный шаблон: галочку «Создать работу» снять нельзя
  Tags: CommonEntityRecord[];
  LockedTags: CommonEntityRecord[];
}

// Ответ смены этапа
export interface AutoJobTemplateInProjectGiver {
  TemplatesFrom: AutoJobTemplateInProject[] | null; // При снятии с текущего этапа
  TemplatesTo: AutoJobTemplateInProject[] | null; // При переводе на новый этап
}

// Заполненный шаблон для создания автоработы
export interface AutoJobTemplateFilled {
  Id: number;
  Text: string;
  AuthorType: AutoJobAuthorType | 0; // 0 — не выбран; окно такой шаблон не отправит
  AuthorId: number | null; // Только для AuthorType.Worker
  ExecutorRoles: number[];
  ExecutorWorkers: number[];
  NeedChecking: boolean;
  Date: string | null;
  Tags: CommonEntityRecord[];
}

export interface ChangeStageWithAutoJobsRequest {
  Id: number; // Проект
  StageId: number; // Новый этап
  Templates: AutoJobTemplateFilled[];
}

export interface AutoJobRefreshAsker {
  Id: number; // Проект
  StageId: number; // Этап, на который переводим
  TemplateId: number;
}

export interface AutoJobAuthorListResponse {
  AuthorHolders: AutoJobAuthorHolder[];
  AuthorLocked: boolean;
  AuthorIsValid: boolean;
}

export interface AutoJobExecutorListResponse {
  ExectutorHolders: AutoJobExecutorHolder[];
  ExecutorLocked: boolean;
}
